import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { ClientContextService } from '../../services/client/client-context.service';
import { Logger } from '../../services/logger/logger.service';

const LOGGER = new Logger('RootRedirectGuard');

/**
 * Point d'entrée `/` : rouvre l'application sur le dernier dossier travaillé (#173,
 * décision 4), à défaut sur le sélecteur.
 *
 * ⚠️ **Unique lecture** de `lastClientId` dans l'application. La préférence n'est
 * pas une source de vérité : si le dossier n'est plus accessible,
 * `ClientContextGuard` renverra de lui-même vers `/home`.
 */
@Injectable({
    providedIn: 'root'
})
export class RootRedirectGuard {
    private _clientContextService = inject(ClientContextService);
    private _router = inject(Router);

    canActivate(): UrlTree {
        const clientId = this._clientContextService.readLastClientId();

        if (clientId === null) {
            LOGGER.debug('Aucun dossier mémorisé, ouverture du sélecteur');
            return this._router.createUrlTree(['/home']);
        }

        LOGGER.debug('Réouverture sur le dernier dossier travaillé', clientId);
        return this._router.createUrlTree(['/c', clientId, 'dashboard']);
    }
}
